import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "vehicles";

const initialState = {
  personal: DEFAULT_ENTITY_STATE,
  approver: DEFAULT_ENTITY_STATE,
  financial: DEFAULT_ENTITY_STATE,
  admin: DEFAULT_ENTITY_STATE,
  director: DEFAULT_ENTITY_STATE,
  insights: DEFAULT_ENTITY_STATE,
};

export const getVehicles = createAsyncThunk(
  `${baseName}/getVehicles`,
  async (role) => {
    const res = await HttpClient.get({
      url: "/vehicles",
      params: {
        role,
      },
    });
    return res?.data;
  }
);

export const vehiclesSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupVehicles(state, { payload }) {
      const { data, role } = payload || {};
      if (!state[role]) return;
      //CONFIGURAR ENTRADA DE DADOS
      state[role].data =
        data?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    //ADM ACTIONS
    addVehicle(state, { payload }) {
      state.admin.data.push(payload);
    },
    updateVehicle(state, { payload }) {
      const { id, changes } = payload;
      const index = state.admin.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.admin.data[index] = {
          ...state.admin.data[index],
          ...changes,
        };
      }
    },
    removeVehicle(state, { payload }) {
      state.admin.data = [
        ...state.admin.data?.filter((item) => item?.id !== payload),
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicles.pending, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "loading";
        state[role].error = null;
      })
      .addCase(getVehicles.rejected, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "failed";
        state[role].error = action.error.message || null;
      })
      .addCase(getVehicles.fulfilled, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "succeeded";
        state[role].error = null;

        //Dados API
        const data = action.payload || [];
        vehiclesSlice.caseReducers.setupVehicles(state, {
          payload: {
            data,
            role,
          },
        });
      });
  },
});

export const { addVehicle, removeVehicle, setupVehicles, updateVehicle } =
  vehiclesSlice.actions;

export default vehiclesSlice.reducer;

export const selectVehiclesByRole = createSelector(
  [(state) => state.vehicles, (state, role) => role],
  (vehiclesState = {}, role = "") => {
    const prevData = vehiclesState[role] || DEFAULT_ENTITY_STATE;

    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectVehicleById = createSelector(
  [selectVehiclesByRole, (state, role, vehicleId) => vehicleId],
  (vehiclesState = {}, vehicleId = "") => {
    return vehiclesState?.data?.find((item) => item?.id === vehicleId) || {};
  }
);
